import React, { useState, useEffect } from "react";
import { Rept, sto } from "../../../../Context/InshData";
import Grid from "@material-ui/core/Grid";

import { useRptAF } from "../../../../St/Reviews/UseStyle";
import HeaderAll from "../../../HeaderAll";

function HeaderJard({ found }) {
  const styf = { fontWeight: "1200" };
  const styfC = { fontWeight: "500" };

  const iInfo = JSON.parse(localStorage.getItem('iInfos')) || {};
  return (
    <Grid item container
      style={{
        paddingTop: "1rem", fontWeight: "bold", fontFamily: "Amiri-Regular",
      }}>
      <HeaderAll Report={true} found={found} />

      <Grid item container style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
        <Grid item xs={12} style={{
          fontFamily: "Amiri-Regular", border: "solid 2px", paddingTop: "0.5rem", paddingBottom: "0.5rem",
          borderRadius: "5px", textAlign: "center",
        }}
        >
          <div style={styf}>
            {iInfo.title}
          </div>
        </Grid>
      </Grid>

      <Grid item container
        style={{
          fontFamily: "Amiri-Regular", padding: "0.3rem", border: "solid 2px",
          borderRadius: "5px", direction: "rtl",
        }}>
        <Grid item xs={12} container>
          <Grid item xs={6} style={{ textAlign: "right" }}>
            {'المخزن'} /{" "} {Rept.auto.safe}
          </Grid>
          <Grid item xs={3}>
            <div style={styfC}>  {"المستخدم"}  {"   /"} {Rept.auto.user}</div>
          </Grid>
          <Grid item xs={3}>
            <div style={styfC}> {"تاريخ الطباعة"} {"    /"} {Rept.nDate}</div>
          </Grid>
        </Grid>

      </Grid>
    </Grid>
  );
}
export default HeaderJard;
